import type { Messages } from "./en";

// Modern Standard Arabic; shown right to left.
export const ar: Messages = {
  "nav.home": "الصفحة الرئيسية لـ LEARNABLE",
  "nav.main": "التنقل الرئيسي",
  "nav.courses": "الدورات",
  "nav.review": "المراجعة",
  "nav.progress": "التقدّم",
  "nav.guide": "الدليل",
  "nav.marketplace": "السوق",
  "nav.streak": "أيام الدراسة المتتالية: {n}",
  "nav.xp": "إجمالي الخبرة: {n} XP",

  "account.menu": "الحساب",
  "account.settings": "الإعدادات",
  "account.guide": "كيف يعمل LEARNABLE",
  "account.signOut": "تسجيل الخروج",

  "common.save": "حفظ",
  "common.saved": "تم الحفظ.",
  "common.saving": "جارٍ الحفظ…",
  "common.cancel": "إلغاء",
  "common.close": "إغلاق",
  "common.pleaseWait": "يُرجى الانتظار…",

  "signin.title": "تسجيل الدخول إلى LEARNABLE",
  "signin.registerTitle": "أنشئ حسابك",
  "signin.email": "البريد الإلكتروني",
  "signin.password": "كلمة المرور",
  "signin.passwordRule": "12 حرفًا على الأقل.",
  "signin.submit": "تسجيل الدخول",
  "signin.register": "إنشاء الحساب",
  "signin.forgot": "هل نسيت كلمة المرور؟",
  "signin.toRegister": "إنشاء حساب جديد",
  "signin.toSignIn": "لديّ حساب بالفعل",
  "signin.language": "اللغة",

  "password.current": "كلمة المرور الحالية",
  "password.new": "كلمة المرور الجديدة (12 حرفًا على الأقل)",
  "password.change": "تغيير كلمة المرور",
  "password.changed": "تم تغيير كلمة المرور. تم تسجيل الخروج من أجهزتك الأخرى.",

  "settings.title": "الإعدادات",
  "settings.intro": "ملفك الشخصي وتفضيلاتك. تُحفظ في حسابك وتُطبَّق على جميع أجهزتك.",
  "settings.profile": "الملف الشخصي",
  "settings.displayName": "الاسم المعروض",
  "signin.emailOrUsername": "البريد الإلكتروني أو اسم المستخدم",
  "signin.username": "اسم المستخدم (اختياري)",
  "signin.usernameHint": "من 3 إلى 30 حرفًا أو رقمًا أو نقطة أو شرطة أو شرطة سفلية. يمكنك تسجيل الدخول به بدل البريد.",
  "settings.username": "اسم المستخدم",
  "settings.usernameHint": "اختياري. يتيح لك تسجيل الدخول بهذا الاسم بدل البريد. لا يراه الآخرون. اتركه فارغًا لإزالته.",
  "settings.displayNameHint": "يظهر بدلًا من بريدك الإلكتروني. اتركه فارغًا لاستخدام البريد الإلكتروني.",
  "settings.email": "البريد الإلكتروني",
  "settings.emailHint": "العنوان الذي تسجّل الدخول به.",
  "settings.language": "اللغة",
  "settings.languageHint": "لغة القوائم والصفحات. تبقى مواد دوراتك وملاحظات الذكاء الاصطناعي بلغة الدورة نفسها.",
  "settings.translationNote": "الترجمة قيد التنفيذ: بعض الشاشات ما زالت باللغة الإنجليزية.",
  "settings.study": "الدراسة",
  "settings.timezone": "المنطقة الزمنية",
  "settings.timezoneHint": "يتبع يوم دراستك وأيامك المتتالية وهدفك اليومي هذه المنطقة الزمنية.",
  "settings.dailyGoal": "الهدف اليومي",
  "settings.dailyGoalHint": "عدد الإجابات في اليوم.",
  "settings.security": "الأمان",
  "settings.signOutHint": "عند تسجيل الخروج تُحذف بيانات حسابك من هذا المتصفح.",

  "guide.title": "كيف يعمل LEARNABLE",
  "guide.intro": "يحوّل LEARNABLE موادك الدراسية إلى أسئلة، ويتحقق من إجاباتك، ويجدول كل مراجعة قبيل أن تنساها.",
  "guide.contents": "المحتويات",
  "guide.structure.title": "1. كيف تُنظَّم الدورة",
  "guide.structure.body": "تُقسَّم الدورة إلى فصول، والفصول إلى موضوعات، والموضوعات إلى مفاهيم. يحتوي كل مفهوم على عناصر تعلّم: المعلومات التي يجب تذكّرها، ويُسأل عن كل منها بسؤال أو أكثر.",
  "guide.material.title": "2. أضف موادك",
  "guide.material.body": "افتح دورة وارفع ملفات PDF أو Word أو PowerPoint أو ملفات نصية أو Markdown، أو الصق نصًا. إذا كانت لديك أسئلة وأجوبة جاهزة، فارفعها في أسطر تبدأ بـ \"Question:\" و\"Answer:\" (أو \"Domanda:\" و\"Risposta:\"): يصبح كل منها مفهومًا من دون استخدام الذكاء الاصطناعي.",
  "guide.curriculum.title": "3. أنشئ المنهج",
  "guide.curriculum.body": "اطلب من الذكاء الاصطناعي أن يقترح فصولًا وموضوعات ومفاهيم من موادك. راجع الاقتراح، وأعد التسمية أو انقل أو احذف ما تشاء، ثم اقبله. لا يتغيّر شيء قبل أن تقبله.",
  "guide.study.title": "4. ادرس مفهومًا",
  "guide.study.body": "افتح مفهومًا واضغط تفعيل: تُعدّ عناصر التعلّم من موادك. اقرأها ثم اضغط «درست هذا المفهوم». يُطرح كل سؤال حتى تجيب عنه جيدًا ثلاث مرات (ليس بالضرورة متتالية)، مع ملاحظات بعد كل إجابة.",
  "guide.answer.title": "5. أجب واحصل على الملاحظات",
  "guide.answer.body": "اكتب إجابتك بكلماتك، أو اضغط \"انطق إجابتك\" لإملائها بصوتك. يتوفّر تلميح، لكنه يخفض نقاط الخبرة إلى النصف. يقيّم الذكاء الاصطناعي المعنى لا الكلمات الحرفية، ويعرض أربع درجات وقائمة بما كان صحيحًا أو ناقصًا أو خاطئًا. الإجابة المرجعية ومصادرها على بُعد نقرة واحدة دائمًا.",
  "guide.disagree.title": "6. إذا لم توافق على التقييم",
  "guide.disagree.body": "اضغط \"Disagree with the grade?\". يمكنك أن تشرح السبب وتطلب من الذكاء الاصطناعي رأيًا ثانيًا (يبقى الرأيان ظاهرين)، أو أن تقيّم الإجابة بنفسك. تقييمك أنت هو المعتمد دائمًا.",
  "guide.review.title": "7. راجع في الوقت المناسب",
  "guide.review.body": "كل إجابة تضع سؤالها في جدول مراجعة: كلما عرفته أفضل، تأخّرت عودته. تعرض صفحة المراجعة ولوحة التحكم ما حان موعده والوقت التقريبي اللازم له.",
  "guide.progress.title": "8. تابع تقدّمك",
  "guide.progress.body": "تحسب الأيام المتتالية الأيام التي درست فيها، وتكافئ نقاط الخبرة الإجابات الصحيحة، ويحدّد الهدف اليومي إيقاعك. تجمع صفحة \"ما تخطئ فيه باستمرار\" الأخطاء التي ظهرت في إجاباتك الأخيرة، مع زر للتدرّب.",
  "guide.organise.title": "9. حافظ على الترتيب",
  "guide.organise.body": "في \"إدارة الأسئلة\" يمكنك تحديد أسئلة منفردة أو فصول وموضوعات ومفاهيم كاملة لحذفها أو إيقافها مؤقتًا أو استئنافها أو نقلها، وتعديل سؤال، وسحب ⠿ لإعادة الترتيب. تُطوى الأقسام الطويلة بالسهم المجاور لعنوانها.",
  "guide.marketplace.title": "10. شارك الدورات واحصل عليها",
  "guide.marketplace.body": "في السوق تجد دورات أنشأها مستخدمون آخرون، حسب الفئة والمستوى واللغة والحجم. قبل إضافة دورة ترى صفحتها: ما تغطيه، ولمن هي، وما ستتعلمه، وفصولها وعدد أسئلتها. يضعها زر \"أضف إلى دوراتي\" في لوحتك: يحدّث المؤلف الأسئلة ولا يمكنك تعديلها، لكن دراستك ملكك (خطتك وإجاباتك ونقاط الخبرة والأولوية التي تعطيها لكل سؤال). لا يمكن تنزيل مواد المؤلف. لمشاركة دورة لك، افتحها واكتب \"صفحة السوق\" الخاصة بها، واحفظها كمسودة ثم انشرها.",
  "guide.glossary.title": "كلمات يستخدمها التطبيق",
  "guide.term.concept": "مفهوم",
  "guide.term.concept.def": "فكرة واحدة من دورتك، مثل تعريف أو قاعدة.",
  "guide.term.item": "عنصر تعلّم",
  "guide.term.item.def": "معلومة واحدة يجب تذكّرها داخل مفهوم، مع أسئلتها والإجابة المتوقعة.",
  "guide.term.active": "Active (مفعّل)",
  "guide.term.active.def": "يشارك المفهوم في الدراسة والمراجعة. المفاهيم الموقوفة أو غير المدروسة لا تشارك.",
  "guide.term.grades": "مرة أخرى · صعب · جيد · سهل",
  "guide.term.grades.def": "مرة أخرى، صعب، جيد، سهل: مدى معرفتك بالإجابة، وهو ما يحدّد موعد عودة السؤال.",
  "guide.term.mastery": "الإتقان",
  "guide.term.mastery.def": "تقدير لمدى تذكّرك لمفهوم ما، بناءً على مراجعاتك.",
  "guide.term.xp": "نقاط الخبرة والأيام المتتالية",
  "guide.term.xp.def": "نقاط تحصل عليها مقابل الإجابات الصحيحة، وعدد الأيام المتتالية التي درست فيها.",
  "guide.privacy.title": "بياناتك",
  "guide.privacy.body": "لا يرى دوراتك وإجاباتك وتقدّمك أحدٌ غيرك. يحوّل متصفحك الإملاء الصوتي إلى نص، ولا يُحفظ سوى النص.",
  "help.button": "مساعدة: {topic}",
  "help.more": "اعرف المزيد",
  "help.nextStep": "أكثر ما يفيدك الآن. المراجعات المستحقة تأتي دائمًا أولًا، ثم المادة الجديدة.",
  "help.courses": "بطاقة لكل دورة. الزر الأخضر لمراجعة ما حان موعده، والزر الأزرق للمتابعة مع شيء جديد.",
  "help.streak": "عدد الأيام المتتالية التي أجبت فيها عن سؤال واحد على الأقل. أجب عن سؤال اليوم لتحافظ عليها.",
  "help.xp": "نقاط خبرة تحصل عليها مقابل الإجابات الصحيحة. استخدام التلميح يخفضها إلى النصف.",
  "help.goal": "عدد الإجابات التي تريد تقديمها كل يوم. يمكنك تغييره من الإعدادات.",
  "help.planner": "عدد الأسئلة التي يحين موعدها حتى كل وقت، والوقت التقريبي الذي تحتاجه.",
  "help.coursePlanner": "هذه الدورة فقط: كم سؤالًا يحين موعده ومتى، وكم يستغرق تقريبًا. المواد الجديدة تحتاج ثلاث إجابات جيدة على الأقل لكل سؤال.",
  "help.activity": "مربع لكل يوم: كلما كان أغمق، أجبت أكثر.",
  "help.concept": "المفهوم فكرة واحدة من دورتك. ابدأ دراسته لتجهيز أسئلته، واقرأ عناصر التعلّم الخاصة به، ثم تدرّب عليها.",
  "help.consolidate": "اضغط الزر بعد قراءة عناصر التعلّم أدناه. يُطرح كل سؤال حتى تجيب عنه جيدًا ثلاث مرات ليثبت.",
  "help.study": "اكتب الإجابة بكلماتك أو أملِها بصوتك. يقيّم الذكاء الاصطناعي المعنى لا الكلمات، ويعرض ما كان صحيحًا أو ناقصًا.",
  "help.questions": "حدّد أسئلة منفردة أو فصلًا أو موضوعًا أو مفهومًا كاملًا، ثم احذفها أو أوقفها مؤقتًا أو انقلها. اسحب ⠿ لتغيير الترتيب.",
  "help.marketplace": "دورات أنشأها مستخدمون آخرون. افتح دورة لترى ما تغطيه وكم سؤالًا فيها؛ أضفها لتدرسها بخطتك الخاصة. يحدّثها مؤلفها باستمرار.",
  "help.weakSpots": "الأخطاء التي ظهرت في إجاباتك الأخيرة مجمّعة حسب المفهوم. تدرّب عليها حتى تختفي من هذه القائمة.",
  "help.material": "ارفع ملفات PDF أو Word أو PowerPoint أو ملفات نصية، أو الصق نصًا. ينشئ LEARNABLE منها الدورة وأسئلتها.",
  "start.title": "كيف يعمل LEARNABLE",
  "start.intro": "أربع خطوات. افتح أيًّا منها لتراها في الدليل.",
  "start.hide": "فهمت، أخفِ هذا",
  "start.reopen": "اعرض كيف يعمل LEARNABLE",
  "start.material.title": "أضف موادك",
  "start.material.body": "أنشئ دورة وارفع ملاحظاتك أو شرائحك أو كتبك، أو الصق نصًا.",
  "start.plan.title": "وافق على الخطة",
  "start.plan.body": "يقترح الذكاء الاصطناعي فصولًا ومفاهيم. غيّر ما تشاء ثم اقبلها.",
  "start.study.title": "ادرس وأجب",
  "start.study.body": "اقرأ مفهومًا، ثم أجب عن أسئلته بكلماتك أو بصوتك.",
  "start.review.title": "راجع في الوقت المناسب",
  "start.review.body": "تعود الأسئلة قبيل أن تنساها. اتبع الزر الأخضر.",
  "nav.community": "المجتمع",
  "community.title": "المجتمع",
  "community.intro": "اطّلع على من يكسب أكبر قدر من الخبرة، وتابع متعلمين آخرين وشجّعهم.",
  "community.tab.leaderboard": "لوحة الصدارة",
  "community.tab.friends": "الأصدقاء",
  "community.period": "الفترة",
  "community.scope": "من",
  "community.period.day": "اليوم",
  "community.period.week": "هذا الأسبوع",
  "community.period.month": "هذا الشهر",
  "community.period.all": "كل الأوقات",
  "community.scope.everyone": "الجميع",
  "community.scope.friends": "الأصدقاء",
  "community.leader": "المتصدّر",
  "community.xp": "{n} نقطة خبرة",
  "community.you": "أنت",
  "community.yourPlace": "ترتيبك",
  "community.empty": "لم يكسب أحد نقاط خبرة في هذه الفترة بعد.",
  "community.emptyFriends": "تابع متعلمين آخرين لتقارن نفسك بهم هنا.",
  "community.windowNote": "تُحسب الأيام بتوقيت UTC وتبدأ الأسابيع يوم الاثنين. يظهر فقط من انضمّوا إلى المجتمع.",
  "community.joinTitle": "انضم إلى المجتمع",
  "community.joinText": "لست في لوحة الصدارة بعد. فعّل الظهور في المجتمع لتظهر فيها ويجدك الآخرون ويتابعوك. لا يرى الآخرون سوى اسمك المعروض ونقاط خبرتك، ولا يرون بريدك الإلكتروني أبدًا.",
  "community.joinButton": "أظهرني في المجتمع",
  "community.needName": "اختر اسمًا معروضًا من الإعدادات أولًا.",
  "community.follow": "متابعة",
  "community.following": "تتابعه",
  "community.friend": "صديق",
  "community.followsYou": "يتابعك",
  "community.since": "يتعلّم هنا منذ {date}",
  "community.statXpTotal": "إجمالي النقاط",
  "community.statXpWeek": "نقاط هذا الأسبوع",
  "community.statStreak": "أيام متتالية",
  "community.statFollowers": "المتابعون",
  "community.statFollowing": "يتابع",
  "community.followingList": "الأشخاص الذين تتابعهم",
  "community.followersList": "متابعوك",
  "community.searchLabel": "ابحث عن متعلمين بالاسم",
  "community.searchPlaceholder": "ابحث بالاسم المعروض",
  "community.search": "بحث",
  "community.noResults": "لم يُعثر على أحد. لا يمكن العثور إلا على من انضمّوا إلى المجتمع.",
  "community.noFollowing": "أنت لا تتابع أحدًا بعد.",
  "community.noFollowers": "لا يوجد متابعون بعد.",
  "community.streakDays": "{n} أيام متتالية",
  "community.xpToday": "{n} نقطة اليوم",
  "community.notFound": "هذا الملف الشخصي غير متاح.",
  "community.seeLeaderboard": "عرض لوحة صدارة المجتمع",
  "course.leaderboardLink": "لوحة صدارة الدورة",
  "course.leaderboardTitle": "لوحة صدارة الدورة",
  "course.leaderboardIntro": "نقاط الخبرة التي كسبها في هذه الدورة كل من يملكها.",
  "course.leaderboardPrivate": "هذه دورة خاصة، لذا لا يوجد في لوحة صدارتها سواك. أما دورات السوق فتُشارَك مع كل من يملكها.",
  "course.leaderboardParticipants": "{n} من المتعلمين يشاركون هذه الدورة.",
  "settings.community": "المجتمع",
  "settings.communityToggle": "أظهرني في المجتمع (لوحات الصدارة والبحث والمتابعة)",
  "settings.communityHint": "معطّل افتراضيًا. لا يرى الآخرون سوى اسمك المعروض ونقاط خبرتك وسلسلة أيامك، ولا يرون بريدك أو دوراتك أو إجاباتك. تحتاج إلى اسم معروض لتفعيله.",
  "study.repeat.badge": "اقتربت: أعدها",
  "study.repeat.title": "راجع الإجابة المرجعية ثم أعدها",
  "study.repeat.body": "كانت إجابتك قوية في معظم النقاط. اقرأ الإجابة المرجعية أعلاه ثم أعد كتابتها بكلماتك. إذا أعدتها جيدًا فتُحتسب صحيحة ويتقدم جدولك، وإلا يعود العنصر إلى المستوى صفر.",
  "study.repeat.label": "إجابتك مرة أخرى",
  "study.repeat.submit": "أعدها",
  "study.repeat.selfGrade": "قيّمها بنفسك بدلًا من ذلك",
  "study.repeat.evalTitle": "إعادتك للإجابة",
  "error.generic": "حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
  "error.transport": "تعذّر الوصول إلى الخادم. تحقق من اتصالك وحاول مرة أخرى.",
  "error.session": "انتهت جلستك. يُرجى تسجيل الدخول مرة أخرى.",
  "error.validation": "بعض المعلومات المُدخلة غير صالحة.",
  "error.notFound": "هذا العنصر لم يعد موجودًا.",
  "error.tooLarge": "هذا الملف كبير جدًا.",
  "error.unsupported": "نوع الملف هذا غير مدعوم. استخدم ملفات PDF أو Word أو PowerPoint أو نصية أو Markdown.",
  "error.aiNotConfigured": "لم يتم إعداد الذكاء الاصطناعي على الخادم بعد.",
  "error.aiUnavailable": "الذكاء الاصطناعي غير متاح مؤقتًا. حاول لاحقًا.",
  "error.aiInvalid": "قدّم الذكاء الاصطناعي ردًا غير صالح للاستخدام. حاول مرة أخرى.",
  "error.state": "هذا الإجراء غير ممكن في الحالة الحالية.",
  "error.server": "حدث خطأ في الخادم. يُرجى المحاولة مرة أخرى.",
  "error.rateLimited": "محاولات كثيرة جدًا. انتظر قليلًا ثم حاول مرة أخرى.",
  "error.managedCourse": "هذه الدورة من السوق: يحدّثها مؤلفها باستمرار، لذا لا يمكن تغيير محتواها هنا.",
  "studyState.NOT_STUDIED": "لم تُدرس",
  "studyState.STUDIED": "تمت دراستها",
  "studyState.ACTIVE": "نشطة",
  "studyState.PAUSED": "متوقفة مؤقتًا",
  "studyState.COMPLETED": "مكتملة",
  "memoryState.NEW": "جديدة",
  "memoryState.LEARNING": "قيد التعلّم",
  "memoryState.REVIEW": "قيد المراجعة",
  "memoryState.RELEARNING": "إعادة تعلّم",
  "memoryState.MASTERED": "متقنة",
  "outcome.AGAIN": "مرة أخرى",
  "outcome.HARD": "صعب",
  "outcome.GOOD": "جيد",
  "outcome.EASY": "سهل",
  "outcomeHelp.AGAIN": "لم أكن أعرفها",
  "outcomeHelp.HARD": "كنت أعرفها بصعوبة",
  "outcomeHelp.GOOD": "كنت أعرفها",
  "outcomeHelp.EASY": "كنت أعرفها بسهولة",
  "classification.CORRECT": "صحيحة",
  "classification.PARTIALLY_CORRECT": "صحيحة جزئيًا",
  "classification.MISCONCEPTION": "فهم خاطئ",
  "classification.WRONG": "غير صحيحة",
  "classification.UNCERTAIN": "غير مؤكدة",
  "role.CORE_TRAINABLE": "أساسية",
  "role.SUPPORTING_TRAINABLE": "داعمة",
  "role.COMMON_TRAP": "فخ شائع",
  "role.INFORMATIONAL": "معلوماتية",
  "role.REFERENCE": "مرجعية",
  "role.OPTIONAL_EXTENSION": "اختيارية",
  "priority.1": "أساسي",
  "priority.2": "مهم",
  "priority.3": "إضافي",
  "label.page": "صفحة {n}",
  "label.pages": "الصفحات {a}–{b}",
  "label.pageShort": "ص {n}",
  "label.pagesShort": "ص {a}–{b}",
  "category.law": "القانون",
  "category.economics_business": "الاقتصاد والأعمال",
  "category.accounting_finance": "المحاسبة والمالية",
  "category.medicine_health": "الطب والصحة",
  "category.sciences": "العلوم",
  "category.mathematics": "الرياضيات",
  "category.engineering": "الهندسة",
  "category.computer_science": "علوم الحاسوب",
  "category.languages": "اللغات",
  "category.humanities": "التاريخ والعلوم الإنسانية",
  "category.arts": "الفنون والموسيقى",
  "category.professional_exams": "الامتحانات المهنية",
  "category.other": "أخرى",
  "level.all": "كل المستويات",
  "level.beginner": "مبتدئ",
  "level.intermediate": "متوسط",
  "level.advanced": "متقدم",
  "size.small": "قصيرة (أقل من 50 سؤالًا)",
  "size.medium": "متوسطة (50–299 سؤالًا)",
  "size.large": "كبيرة (300+ سؤال)",
  "sort.popular": "الأكثر اختيارًا",
  "sort.newest": "الأحدث",
  "sort.largest": "الأكثر أسئلة",
  "lang.it": "الإيطالية",
  "lang.en": "الإنجليزية",
  "price.free": "مجاني",
  "common.loading": "جارٍ التحميل…",
  "common.tryAgain": "حاول مرة أخرى",
  "common.dismiss": "إخفاء",
  "common.delete": "حذف",
  "common.edit": "تعديل",
  "common.rename": "إعادة تسمية",
  "common.title": "العنوان",
  "common.description": "الوصف",
  "common.continue": "متابعة",
  "common.search": "بحث",
  "common.add": "إضافة",
  "common.remove": "إزالة",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.collapse": "طيّ {label}",
  "common.expand": "توسيع {label}",
  "drag.item": "عنصر",
  "drag.reorder": "إعادة ترتيب {label}",
  "drag.pickedUp": "تم التقاط {label}، الموضع {pos} من {total}.",
  "drag.over": "أصبح {label} في الموضع {pos} من {total}.",
  "drag.dropped": "تم إسقاط {label} في الموضع {pos} من {total}.",
  "drag.droppedPlain": "تم إسقاط {label}.",
  "drag.cancelled": "أُلغي نقل {label}.",
  "drawing.loadFailed": "تعذّر تحميل الرسم.",
  "course.authorOrder": "يحدد المؤلف ترتيب هذه الدورة.",
  "priority.yours": "أولويتك",
  "priority.label": "الأولوية",
  "priority.author": "المؤلف: {name}",
  "priority.useAuthor": "استخدم أولوية المؤلف",
  "editTitle.rename": "إعادة تسمية {label}",
  "label.course": "الدورة",
  "label.chapter": "الفصل",
  "label.topic": "الموضوع",
  "label.concept": "المفهوم",
  "library.heading": "دوراتي",
  "library.count.one": "{n} دورة",
  "library.count.other": "{n} دورات",
  "library.shownOf": "عرض {shown} من {total}",
  "library.search": "ابحث في الدورات",
  "library.show": "عرض",
  "library.sortBy": "ترتيب حسب",
  "library.new": "+ دورة جديدة",
  "library.marketplace": "🛒 السوق",
  "library.empty": "لا توجد دورات بعد. أنشئ دورة ثم أضف مواد الدراسة أو أسئلتك وأجوبتك.",
  "library.createFirst": "أنشئ دورتك الأولى",
  "library.noMatch": "لا توجد دورة تطابق هذا البحث أو التصفية.",
  "libStatus.all": "كل الدورات",
  "libStatus.in_progress": "قيد التقدم",
  "libStatus.not_started": "لم تبدأ",
  "libStatus.due": "مراجعات مستحقة",
  "libStatus.completed": "لا جديد لتتعلمه",
  "libStatus.paused": "متوقفة مؤقتًا",
  "libStatus.archived": "مؤرشفة",
  "libSort.recent_study": "الأحدث دراسة",
  "libSort.recent_created": "الأحدث إنشاءً",
  "libSort.alphabetical": "أبجدي",
  "libSort.most_due": "الأكثر مراجعات مستحقة",
  "card.marketplacePill": "🛒 من السوق · بواسطة {author}",
  "card.marketplaceHint": "يحدّث المؤلف المحتوى باستمرار، ودراستك ملكك.",
  "card.continue": "متابعة",
  "card.next": "التالي",
  "card.archived": "مؤرشف",
  "card.paused": "متوقف مؤقتًا",
  "card.conceptsStudied": "مفاهيم تمت دراستها",
  "card.itemsIntroduced": "عناصر تعلّم تم تقديمها",
  "card.moreFor": "المزيد لـ {title}",
  "menu.details": "تفاصيل الدورة",
  "menu.material": "مواد الدراسة",
  "menu.progress": "التقدم",
  "menu.publish": "🛒 انشر في السوق",
  "menu.pause": "إيقاف مؤقت",
  "menu.resume": "استئناف",
  "menu.archive": "أرشفة",
  "menu.restore": "استعادة",
  "menu.delete": "حذف…",
  "menu.confirmOwn": "حذف \"{title}\"؟ ستُحذف فصولها وأسئلتها ومواردها وإجاباتك نهائيًا. أرشِفها بدلًا من ذلك للاحتفاظ بكل شيء.",
  "menu.confirmMarketplace": "حذف \"{title}\"؟ يمكنك إضافتها مجددًا من السوق مجانًا.",
  "newCourse.aria": "دورة جديدة",
  "newCourse.language": "لغة المواد",
  "newCourse.create": "إنشاء الدورة",
  "learn.resume.label": "استئناف التدريب",
  "learn.resume.hint": "تابع الجولة التي تركتها دون إكمال",
  "learn.study.label": "تعلّم التالي",
  "learn.study.hint": "ادرس {title}",
  "learn.study.hintNone": "تعلّم مواد جديدة",
  "learn.activate.label": "ابدأ التعلّم",
  "learn.activate.hint": "حضّر أسئلة {title} وابدأ دراسته",
  "learn.activate.hintNone": "ابدأ دراسة المفهوم التالي",
  "learn.setup.label": "أضف مواد",
  "learn.setup.hint": "أضف مواد دراسة أو أسئلتك للبدء",
  "learn.none.label": "تم تعلّم كل شيء ✓",
  "learn.none.hint": "تم تعلّم كل ما في هذه الدورة",
  "review.none": "✓ لا شيء للمراجعة الآن",
  "review.noneTitle": "لا شيء في هذه الدورة يحتاج مراجعة الآن",
  "review.aria.one": "مراجعة {n} عنصر",
  "review.aria.other": "مراجعة {n} عناصر",
  "review.button": "مراجعة",
  "course.practiceHard": "تدرّب على الأسئلة الصعبة",
  "course.chapters": "الفصول",
  "course.chaptersEmpty": "أضف فصلًا ثم أضف إليه مواد الدراسة.",
  "course.chapterMeta": "{active} من {total} مفاهيم نشطة · الإتقان {mastery}",
  "course.newChapter": "عنوان الفصل الجديد",
  "course.addChapter": "إضافة فصل",
  "course.curriculum": "المنهج",
  "course.fallback": "الدورة",
  "course.allMaterial": "كل مواد الدراسة",
  "course.manageQuestions": "إدارة الأسئلة",
  "course.weakSpots": "ما تخطئ فيه باستمرار",
  "chapter.gone": "هذا الفصل لم يعد موجودًا.",
  "chapter.topics": "الموضوعات",
  "chapter.starting": "جارٍ بدء التحليل…",
  "chapter.analyze": "تحليل المواد الجديدة",
  "chapter.analyzeHint": "يقترح الذكاء الاصطناعي موضوعات ومفاهيم من المواد التي لم تُحلَّل بعد. تراجع الاقتراح قبل أن يتغير أي شيء.",
  "chapter.noMaterial": "لا توجد مواد جديدة لتحليلها في هذا الفصل. ارفع مواد أولًا.",
  "chapter.empty": "لا توجد موضوعات بعد. ارفع مواد بالأسفل ثم حلّلها.",
  "chapter.topicMeta": "{active} من {total} مفاهيم نشطة",
  "topic.gone": "هذا الموضوع لم يعد موجودًا.",
  "topic.concepts": "المفاهيم",
  "topic.empty": "لا توجد مفاهيم في هذا الموضوع.",
  "topic.needsReview": "يحتاج مراجعة المصدر",
  "topic.conceptMeta": "{state} · الإتقان {mastery}",
  "unit.item.one": "{n} عنصر",
  "unit.item.other": "{n} عناصر",
  "unit.answer.one": "{n} إجابة",
  "unit.answer.other": "{n} إجابات",
  "consolidate.continue": "متابعة التثبيت",
  "consolidate.unfinished": "دفعتك المكوّنة من {items} غير مكتملة: تبقّى {left}. الإجابات التي قدّمتها محفوظة.",
  "consolidate.resume": "استئناف",
  "consolidate.doneTitle": "تم التثبيت",
  "consolidate.doneBody": "أكمل كل عنصر في هذا المفهوم جولات التثبيت. ستعود في مراجعاتك عند استحقاقها.",
  "consolidate.title": "هل درست هذا المفهوم؟",
  "consolidate.body": "اقرأ أولًا ما يجب دراسته أعلاه. عندما تكون مستعدًا، يُطرح كل سؤال حتى تجيب عنه جيدًا {n} مرات (ليس بالضرورة متتالية)، مع ملاحظات بعد كل إجابة.",
  "consolidate.batch": "هذه الدفعة: {items} · {answers}",
  "consolidate.more.one": "عنصر إضافي ({n}) ينتظر دفعة لاحقة",
  "consolidate.more.other": "{n} عناصر إضافية تنتظر دفعة لاحقة",
  "consolidate.button": "لقد درست هذا المفهوم",
  "breadcrumb.aria": "مسار التنقل",
  "dash.title": "لوحة التحكم",
  "dash.loading": "جارٍ تحميل لوحتك…",
  "dash.aside": "دراستك",
  "dash.today": "اليوم",
  "dash.xpTodayPlus": "+{n} نقطة اليوم",
  "dash.goal": "الهدف {done}/{target}",
  "dash.tzNote": "تتبع أيام دراستك (السلسلة والهدف ونقاط اليوم) المنطقة {zone}. هذا الجهاز في {device}.",
  "dash.tzUse": "استخدم {zone}",
  "next.title": "خطوتك التالية",
  "next.resumeTitle": "متابعة الترسيخ · الإجابة الجيدة {round} من {total}",
  "next.answersLeft": "تبقّى {n} إجابات",
  "next.resume": "استئناف",
  "next.minutes": "حوالي {n} دقيقة",
  "next.startReview": "ابدأ المراجعة",
  "next.learnTitle": "تابع التعلّم: {concept}",
  "next.nextConcept": "المفهوم التالي",
  "next.learn": "تعلّم",
  "next.setupTitle": "جهّز {concept}",
  "next.theNextConcept": "المفهوم التالي",
  "next.setupDetail": "{course} · فعّله لتحضير أسئلته",
  "next.setup": "تجهيز",
  "next.addMaterialTitle": "أضف مواد إلى {course}",
  "next.yourCourse": "دورتك",
  "next.addMaterialDetail": "ارفع مواد دراسة أو أسئلتك وأجوبتك لبناء مفاهيمها.",
  "next.firstCourse": "ابدأ دورتك الأولى",
  "next.firstCourseDetail": "أنشئ دورة ثم أضف مواد أو أسئلتك.",
  "next.caughtUp": "أنت على اطلاع كامل",
  "next.caughtUpDetail": "لا شيء مستحق ولا توجد مواد جديدة بانتظارك.",
  "streak.title": "السلسلة اليومية",
  "streak.unit.one": "يوم",
  "streak.unit.other": "أيام",
  "streak.done": "اكتمل اليوم. عُد غدًا لتواصل.",
  "streak.keep": "أجب عن سؤال واحد اليوم للحفاظ على سلسلتك.",
  "streak.start": "أجب عن سؤال اليوم لتبدأ سلسلة.",
  "streak.last7": "آخر 7 أيام",
  "streak.studied": "درست",
  "streak.noStudy": "لا دراسة",
  "xp.title": "الخبرة",
  "xp.how": "كيف تعمل نقاط الخبرة",
  "xp.howBody": "كل إجابة صحيحة عن العنصر نفسه تمنح أكثر: 10 نقاط في المرة الأولى ثم 20 و30… حتى 150. التلميح يخفّض نقاط تلك الإجابة إلى النصف. الإجابات الخاطئة لا تمنح شيئًا لكنها لا تعيد تقدمك إلى الصفر. تكافئ النقاط التدريب ولا تغيّر جدول مراجعاتك أبدًا.",
  "goal.title": "الهدف اليومي",
  "goal.sr": "الهدف اليومي: {done} من {target} إجابات مكتملة اليوم، {percent} بالمئة.",
  "goal.answersToday": "{done} / {target} إجابات اليوم",
  "goal.perDay": "الإجابات في اليوم",
  "goal.edit": "تعديل الهدف",
  "goal.invalid": "اختر عددًا صحيحًا من 1 إلى 500.",
  "planner.title": "مخطط الوقت",
  "planner.now": "الآن",
  "planner.1h": "بعد ساعة",
  "planner.4h": "بعد 4 ساعات",
  "planner.1d": "بعد يوم",
  "planner.3d": "بعد 3 أيام",
  "planner.7d": "بعد 7 أيام",
  "planner.dueNow": "{n} مستحقة الآن: حوالي {min} دقيقة",
  "planner.caption": "المراجعات المستحقة حتى كل وقت، بما فيها المتأخرة",
  "planner.dueBy": "الاستحقاق بحلول",
  "planner.items": "العناصر",
  "planner.hint": "بناءً على جدول مراجعاتك الحالي؛ يتغير أثناء دراستك. يشمل كل صف كل ما يستحق قبله.",
  "activity.title": "النشاط",
  "activity.seeMore": "عرض المزيد",
  "activity.future": "{day}: في المستقبل",
  "activity.day": "{day}: {answers}",
  "activity.dayXp": "{day}: {answers}، {xp} نقطة",
  "activity.aria": "تقويم النشاط: {days}، {answers}",
  "activity.summary": "{days} · {answers}",
  "unit.activeDay.one": "{n} يوم نشط",
  "unit.activeDay.other": "{n} أيام نشطة",
  "activity.less": "أقل",
  "activity.more": "أكثر",
  "activity.legendFuture": "المستقبل",
  "pb.curriculumHint": "مقدار المواد التي درستها وفعّلتها.",
  "pb.conceptsActive": "المفاهيم النشطة",
  "pb.activeOf": "{active} من {total}",
  "pb.memory": "الذاكرة",
  "pb.memoryHint": "مدى احتفاظك بما تتدرب عليه. الإتقان تقدير مبني على مراجعاتك.",
  "pb.mastery": "الإتقان (تقدير)",
  "pb.itemsTrained": "عناصر قيد التدريب",
  "pb.markedHard": "موسومة صعبة",
  "pb.dueNow": "مستحقة الآن",
  "pb.laterToday": "لاحقًا اليوم",
  "pb.tomorrow": "غدًا",
  "pb.next7": "الأيام السبعة القادمة",
  "pb.newToLearn": "جديدة للتعلم",
  "pb.overdue.one": "{n} سؤال متأخر: ابدأ بها.",
  "pb.overdue.other": "{n} أسئلة متأخرة: ابدأ بها.",
  "pb.caption": "الأسئلة المستحقة قريبًا في هذه الدورة والوقت التقريبي لها",
  "pb.when": "متى",
  "pb.questions": "الأسئلة",
  "pb.time": "الوقت",
  "pb.minutes": "~{n} دقيقة",
  "study.intent.LEARN": "تعلّم",
  "study.intent.SCHEDULED_REVIEW": "مراجعة",
  "study.intent.PRACTICE": "تدريب",
  "study.intent.EXAM": "امتحان",
  "study.intent.CONSOLIDATION": "تثبيت",
  "study.round": "الإجابة الجيدة {n} من {total}",
  "study.progressAria": "التقدم في هذه الجلسة",
  "study.progress": "{n} من {total}",
  "study.xpSessionAria": "{n} نقطة في هذه الجلسة",
  "study.ownReview": "مراجعة ذاتية: لا تغيير في خطتك ولا نقاط",
  "study.leaveResume": "مغادرة (استئناف لاحقًا)",
  "study.end": "إنهاء الجلسة",
  "study.preparing": "جارٍ تحضير جلستك…",
  "study.empty.title": "لا شيء للدراسة الآن",
  "study.empty.body": "لا شيء مؤهل لهذه الجلسة. فعّل مفهومًا لإضافة مواد جديدة أو عُد عند استحقاق المراجعات.",
  "study.empty.back": "العودة إلى الدورة",
  "study.newMaterial": "مواد جديدة",
  "study.keyPoints": "النقاط الأساسية",
  "study.sources": "المصادر",
  "study.ready": "أنا جاهز: اختبرني",
  "study.answering": "الإجابة",
  "study.drawHint": "ارسم إجابتك أدناه. يقارنها الذكاء الاصطناعي بالرسم المرجعي.",
  "study.note": "ملاحظة (اختيارية)",
  "study.yourAnswer": "إجابتك",
  "study.notePlaceholder": "أي شيء تضيفه إلى رسمك…",
  "study.answerPlaceholder": "أجب بكلماتك الخاصة…",
  "study.stopListening": "إيقاف الاستماع",
  "study.speak": "انطق إجابتك",
  "study.evaluating": "جارٍ التقييم…",
  "study.submit": "إرسال",
  "study.skip": "تخطَّ هذا السؤال",
  "study.dictationOn": "يُحوَّل الإملاء إلى نص بواسطة متصفحك وقد يرسل الصوت إلى خدمة الكلام التابعة له. يُحفظ النص فقط؛ عدّله قبل الإرسال.",
  "study.dictationOff": "تتطلب الإجابات الصوتية Chrome أو Edge أو Safari. يمكنك كتابة إجابتك هنا.",
  "study.drawingCompare": "رسمك والمرجع",
  "study.yourDrawing": "رسمك",
  "study.reference": "المرجع",
  "study.gradedByYou": "قيّمته أنت",
  "study.needsGrade": "يحتاج تقييمك",
  "study.firstEval": "التقييم الأول",
  "study.secondOpinion": "رأي ثانٍ",
  "study.afterObjection": "بعد اعتراضك: «{text}»",
  "study.referenceSummary": "الإجابة المرجعية والمصادر",
  "study.studyConcept": "📖 ادرس هذا المفهوم",
  "study.gradeHow": "ما مدى معرفتك بها؟",
  "study.gradeYourself": "أو قيّمها بنفسك",
  "study.yourGrade": "تقييمك",
  "study.retryEval": "أعد محاولة التقييم",
  "study.skipNow": "تخطَّ الآن",
  "study.disagree": "لا توافق على التقييم؟",
  "study.notMemorized": "لم يُحفظ بعد: ستراه مجددًا في هذه الجلسة.",
  "study.levelNext": "المستوى {from} ← {to}. المراجعة التالية: {when}",
  "study.practiceNote": "التدريب لا يغيّر جدول مراجعاتك.",
  "study.complete": "اكتملت الجلسة",
  "study.xpSessionPlus": "+{n} نقطة في هذه الجلسة",
  "study.answeredIn": "{answers} في حوالي {min} دقيقة.",
  "study.wentWell": "{n} منها سار بشكل جيد.",
  "study.steady": "عمل ثابت: بدأ هذا يترسخ.",
  "study.comeBack": "التي لم تسر جيدًا تعود قريبًا، وهكذا ترسخ.",
  "study.stillDue": "لا يزال مستحقًا الآن: {n} (حوالي {min} دقيقة).",
  "study.nothingDue": "لا شيء آخر مستحق الآن.",
  "study.done": "تم",
  "study.noXp": "هذه الإجابة لا تمنح نقاطًا (تدريب أو لم يحن موعد مراجعتها).",
  "study.correctXp": "إجابة صحيحة: +{n} نقطة",
  "study.halfXp": "(استُخدم تلميح: نصف النقاط)",
  "study.hintLabel": "تلميح",
  "study.noHint": "لا يوجد تلميح لهذا السؤال.",
  "study.showHint": "إظهار التلميح",
  "study.hintHalves": "استخدام تلميح يخفّض نقاط هذه الإجابة إلى النصف.",
  "study.revealHint": "اكشف التلميح",
  "study.plusZero": "+0 نقطة",
  "study.onlyCorrectSelf": "الإجابات الصحيحة فقط تمنح نقاطًا: تقييمك بصعب أو جيد أو سهل يُحتسب أيضًا.",
  "study.onlyCorrect": "الإجابات الصحيحة تمامًا فقط تمنح نقاطًا. يُحفظ تقدمك نحو المكافأة التالية.",
  "study.awardCorrect": "صحيحة",
  "study.awardHint": "استُخدم تلميح",
  "study.ordinal": "الإجابة الصحيحة رقم {n} لهذا العنصر",
  "study.ordinalHalf": "الإجابة الصحيحة رقم {n} لهذا العنصر، نصف {base}",
  "study.batchDone": "تم تثبيت الدفعة",
  "study.correctAnswers": "الإجابات الصحيحة",
  "study.xpThisSession": "نقاط هذه الجلسة",
  "study.whatNext": "ما الذي سيحدث لاحقًا",
  "study.whatNextBody": "تعود العناصر التي كانت جولتها الأخيرة صحيحة إلى المراجعة بعد نحو 4 ساعات؛ وتنتظر البقية الدفعة التالية.",
  "study.waiting.one": "عنصر إضافي ({n}) في الانتظار",
  "study.waiting.other": "{n} عناصر إضافية في الانتظار",
  "study.batchNotAll": "انتهت هذه الدفعة وليس المفهوم كله: {waiting}.",
  "study.allRounds": "كل عنصر في هذا المفهوم كان ينتظر أُجيب عنه جيدًا ثلاث مرات.",
  "study.nextBatch": "الدفعة التالية",
  "study.conceptCosts": "الاطلاع على المفهوم الآن يُحتسب استخدامًا لتلميح: ستمنح هذه الإجابة نصف النقاط.",
  "study.openConcept": "افتح المفهوم",
  "study.dontRemember": "📖 لا تتذكر؟ ادرس هذا المفهوم",
  "study.refDrawing": "الرسم المرجعي",
  "dispute.title": "اطلب من الذكاء الاصطناعي إعادة النظر",
  "dispute.testAi": "الذكاء الاصطناعي التجريبي لا يقرأ اعتراضك: سيكرر الرأي الثاني التقييم نفسه. قيّمها بنفسك أدناه.",
  "dispute.why": "لماذا لا توافق؟",
  "dispute.placeholder": "اذكر ما أخطأ فيه التقييم…",
  "dispute.hint": "يرى الذكاء الاصطناعي اعتراضك ويقيّم مجددًا. يبقى الرأيان ظاهرين؛ ولا يتغير تقييمك إلا إذا اخترته أدناه.",
  "dispute.asking": "جارٍ السؤال…",
  "dispute.ask": "اطلب رأيًا ثانيًا",
  "eval.correct": "صحيح",
  "eval.complete": "مكتمل",
  "eval.understanding": "الفهم",
  "eval.precise": "دقيق",
  "eval.Strong": "قوي",
  "eval.Partial": "جزئي",
  "eval.Weak": "ضعيف",
  "eval.scoreBreakdown": "تفاصيل الدرجات",
  "eval.right": "صحيح",
  "eval.missing": "ناقص",
  "eval.misconception": "فهم خاطئ",
  "eval.materialSays": "تقول المادة",
  "eval.covered": "ما غطّته إجابتك",
  "eval.failed": "تعذّر تقييم الإجابة.",
  "eval.aiEvaluation": "تقييم الذكاء الاصطناعي: {verdict}",
  "eval.insufficient": "لا تغطي مواد الدورة هذا بما يكفي لتقييمه.",
  "eval.testAiTitle": "ذكاء اصطناعي تجريبي.",
  "eval.testAiBody": "يأتي هذا التقييم من بديل يقارن الكلمات فقط بالمرجع: لا يفهم إعادة الصياغة ولا الاعتراضات. راجع المرجع وقيّم بنفسك أو اربط ذكاءً اصطناعيًا حقيقيًا.",
  "conceptPanel.title": "ادرس هذا المفهوم",
  "conceptPanel.next": "انتهيت من الدراسة — السؤال التالي",
  "conceptPanel.closeAria": "أغلق المفهوم",
  "conceptPanel.loading": "جارٍ تحميل المفهوم…",
  "conceptPanel.openFull": "افتح صفحة المفهوم الكاملة في علامة تبويب جديدة",
  "dictation.blocked": "الميكروفون محظور. اسمح به من إعدادات الموقع في متصفحك لتتمكن من الإملاء.",
  "dictation.network": "يتطلب التعرف على الكلام اتصالًا بالإنترنت.",
  "dictation.noMic": "لم يُعثر على ميكروفون.",
  "dictation.stopped": "توقف التعرف على الكلام بشكل غير متوقع. يمكنك متابعة الكتابة.",
  "concept.activate": "تفعيل",
  "concept.activateHelp": "يحضّر أسئلة هذا المفهوم من موادك لتتمكن من دراسته.",
  "concept.markStudied": "وضع علامة كمدروس",
  "concept.markStudiedHelp": "درسته في مكان آخر: يُسجَّل دون تحضير أسئلة بعد.",
  "concept.activateAgainHelp": "يدرسه مجددًا: تعود أسئلته إلى جلساتك.",
  "concept.pause": "إيقاف مؤقت",
  "concept.pauseHelp": "يوقف أسئلته لبعض الوقت. لا شيء يُفقد.",
  "concept.deactivate": "إلغاء التفعيل",
  "concept.deactivateHelp": "يخرجه من الدراسة والمراجعات. تُحفظ إجاباتك وسجلك.",
  "concept.resume": "استئناف",
  "concept.resumeHelp": "يعيد أسئلته إلى الدراسة والمراجعات.",
  "concept.sourceDeleted": "حُذفت المواد التي جاء منها هذا المفهوم. احتفظ به أو عدّله أو احذفه.",
  "concept.manage": "إدارة هذا المفهوم",
  "concept.loadingItems": "جارٍ تحميل عناصر التعلّم…",
  "concept.preparing": "جارٍ تحضير عناصر التعلّم…",
  "concept.itemsFailed": "تعذّر تحضير عناصر التعلّم.",
  "concept.noSource": "ليس لهذا المفهوم مواد مصدر لبناء عناصر التعلّم منها.",
  "concept.whatToStudy": "ما الذي تدرسه",
  "concept.reviewOwnHelp": "اختبر نفسك في هذا المفهوم متى شئت. لا يغيّر خطة مراجعتك ولا يمنح نقاطًا.",
  "concept.reviewOwn": "🔁 راجع بنفسك",
  "concept.readThen": "اقرأ هذه ثم اضغط \"لقد درست هذا المفهوم\" أدناه للتدرّب عليها.",
  "concept.testMe": "🔁 اختبرني في هذا",
  "concept.hideDetails": "إخفاء التفاصيل",
  "concept.details": "التفاصيل",
  "concept.level": "المستوى {n}",
  "concept.markedHard": "موسوم صعب",
  "concept.notTraining": "ليس قيد التدريب",
  "concept.state": "الحالة",
  "concept.levelLabel": "المستوى",
  "concept.nextReview": "المراجعة التالية",
  "concept.reviews": "المراجعات",
  "concept.lapses": "حالات النسيان",
  "concept.inTraining": "قيد التدريب",
  "concept.questions": "الأسئلة",
  "concept.sourcesTitle": "المصادر",
  "concept.loadingSources": "جارٍ تحميل المصادر…",
  "concept.noSources": "لا توجد مقاطع من المصادر.",
  "concept.misconceptions": "مفاهيم خاطئة متكررة",
  "drawing.answerBy": "أجب بالرسم",
  "drawing.studentsDraw": "يجيب الطلاب عن هذا السؤال بالرسم. يقارن الذكاء الاصطناعي رسمهم بهذا الرسم.",
  "drawing.youDraw": "تجيب عن هذا السؤال بالرسم. يقارن الذكاء الاصطناعي رسمك بهذا الرسم.",
  "drawing.referenceAlt": "الرسم المرجعي",
  "drawing.explain": "للأسئلة التي يُجاب عنها برسم (جزيء أو مخطط أو رسم بياني): أضف الرسم الصحيح وسيرسم الطلاب إجاباتهم بدل كتابتها.",
  "drawing.save": "احفظ هذا الرسم",
  "drawing.replace": "استبدل بصورة…",
  "drawing.upload": "ارفع الرسم…",
  "drawing.drawNew": "ارسم رسمًا جديدًا",
  "drawing.drawHere": "ارسمه هنا",
  "drawing.words": "أجب بالكلمات بدلًا من ذلك",
  "drawing.tools": "أدوات الرسم",
  "drawing.pen": "✏️ قلم",
  "drawing.eraser": "🧽 ممحاة",
  "drawing.thick": "خط سميك",
  "drawing.thin": "خط رفيع",
  "drawing.undo": "↶ تراجع",
  "drawing.clear": "مسح",
  "drawing.area": "منطقة الرسم: ارسم إجابتك هنا",
  "drawing.photoUpload": "رسمته على ورقة؟ ارفع صورة بدلًا من ذلك",
  "drawing.photoError": "هذا الملف ليس صورة يستطيع هذا المتصفح قراءتها. جرّب صورة JPEG أو PNG.",
  "drawing.photoAlt": "صورتك للرسم",
  "drawing.drawInstead": "ارسم بدلًا من ذلك",
  "q.title": "الأسئلة",
  "q.introOwn": "حدّد أسئلة لحذفها أو إيقافها مؤقتًا أو استئنافها أو نقلها؛ اسحب ⠿ لإعادة الترتيب؛ وعدّل سؤالًا لتصحيح عنوانه أو صياغته أو إجابته المتوقعة.",
  "q.introManaged": "هذه الدورة من السوق: يحدّث مؤلفها الأسئلة باستمرار. حدّد أسئلة لإيقافها مؤقتًا أو استئنافها، أو امنحها أولويتك الخاصة (أنت وحدك تراها).",
  "q.search": "ابحث في الأسئلة",
  "q.searchPlaceholder": "ابحث في الأسئلة والأجوبة",
  "q.allPriorities": "كل الأولويات",
  "q.priorityOnly": "{label} فقط ({n})",
  "q.deselectAll": "إلغاء تحديد الكل",
  "q.selectAll": "تحديد الكل ({n})",
  "q.selectAllShown": "تحديد كل المعروض ({n})",
  "q.collapseAll": "طيّ الكل",
  "q.expandAll": "توسيع الكل",
  "q.selectedAria": "الأسئلة المحددة",
  "q.selectedCount": "تم تحديد {n}",
  "q.moveTo": "نقل إلى…",
  "q.setPriority": "تعيين الأولوية",
  "q.setPriorityPlaceholder": "تعيين الأولوية…",
  "q.reviewSelectedHelp": "اختبر نفسك الآن في الأسئلة المحددة. لا يغيّر خطة مراجعتك ولا يمنح نقاطًا.",
  "q.clearSelection": "مسح التحديد",
  "q.verb.delete": "تم حذف",
  "q.verb.pause": "تم إيقاف",
  "q.verb.resume": "تم استئناف",
  "q.verb.move": "تم نقل",
  "q.verb.set_priority": "تم تحديث",
  "unit.question.one": "{n} سؤال",
  "unit.question.other": "{n} أسئلة",
  "unit.chapter.one": "{n} فصل",
  "unit.chapter.other": "{n} فصول",
  "unit.topic.one": "{n} موضوع",
  "unit.topic.other": "{n} موضوعات",
  "unit.concept.one": "{n} مفهوم",
  "unit.concept.other": "{n} مفاهيم",
  "unit.group.one": "{n} مجموعة أُفرغت",
  "unit.group.other": "{n} مجموعات أُفرغت",
  "q.newConcepts.one": "{n} مفهوم جديد",
  "q.newConcepts.other": "{n} مفاهيم جديدة",
  "q.removedConcepts.one": "أُزيل {n} مفهوم فارغ",
  "q.removedConcepts.other": "أُزيلت {n} مفاهيم فارغة",
  "q.noticeBulk": "{verb} {questions}{extra}.",
  "q.noticeDeleted": "تم حذف {questions}.",
  "q.noticeDeletedGroups": "تم حذف {questions} و{groups}.",
  "q.confirmDelete": "حذف {questions}؟ ستُحذف أيضًا إجاباتها وسجل مراجعتها.{also}",
  "q.confirmAlso": " كما تُحذف {groups} التي تبقى بلا أسئلة.",
  "q.emptySearch": "لا يوجد سؤال يطابق هذا البحث.",
  "q.empty": "لا توجد أسئلة بعد. فعّل مفهومًا أو استورد أسئلتك وأجوبتك.",
  "q.clearToReorder": "امسح البحث لإعادة ترتيب هذه الأسئلة.",
  "q.select": "حدّد: {text}",
  "q.otherWordings.one": "+{n} صياغة أخرى",
  "q.otherWordings.other": "+{n} صياغات أخرى",
  "q.editAria": "تعديل السؤال",
  "q.titleLabel": "العنوان (يظهر في القوائم)",
  "q.wordings": "صياغات السؤال",
  "q.wording": "الصياغة {n}",
  "q.addWording": "+ أضف صياغة أخرى",
  "q.expected": "الإجابة المتوقعة",
  "q.prio1": "أساسي: الجوهر، يجب معرفته",
  "q.prio2": "مهم: ينبغي معرفته",
  "q.prio3": "إضافي: ملحق وتفاصيل أعمق",
  "q.keyPoints": "النقاط الأساسية (واحدة في كل سطر، حتى 10)",
  "q.moveAria": "نقل الأسئلة",
  "q.moveHeading": "نقل {questions} إلى",
  "q.choose": "اختر موضوعًا أو مفهومًا…",
  "q.topicOption": "الموضوع: {title} (يحتفظ كل سؤال بمفهومه)",
  "q.conceptOption": "   ↳ إلى المفهوم: {title}",
  "q.removeEmpty": "أزل المفاهيم التي تبقى بلا أسئلة",
  "q.moveHint": "تحتفظ الأسئلة بتقدم مراجعتها. في مفهوم غير نشط لا تُراجع حتى يصبح نشطًا.",
  "q.move": "نقل",
  "q.groupSelect": "حدّد كل الأسئلة في {label}",
  "mat.chapterTitle": "مواد الفصل",
  "mat.collapseLabel": "مواد الدراسة",
  "mat.files.one": "{n} ملف",
  "mat.files.other": "{n} ملفات",
  "mat.uploading": "جارٍ الرفع…",
  "mat.upload": "ارفع مواد",
  "mat.uploadQa": "ارفع أسئلة وأجوبة",
  "mat.paste": "الصق نصًا",
  "mat.howTo": "كيف تُحضّر الأسئلة والأجوبة",
  "mat.howToBody": "ارفع ملف PDF أو Word أو نصيًا أو Markdown يبدأ فيه كل سؤال بـ \"Domanda:\" وإجابته المتوقعة بـ \"Risposta:\" (أو \"Question:\" / \"Answer:\") في بداية السطر. تجمع العناوين الأسئلة في موضوعات.",
  "mat.howToBody2": "يتحول كل سؤال إلى مفهوم موسوم بأنه غير مدروس، وإجابتك هي الإجابة المتوقعة. فعّله لتبدأ المراجعة. لا يُستخدم الذكاء الاصطناعي في الاستيراد.",
  "mat.loading": "جارٍ تحميل المواد…",
  "mat.none": "لا توجد مواد بعد. ارفع ملفات PDF أو Word أو PowerPoint أو نصية أو Markdown.",
  "mat.file": "الملف",
  "mat.status": "الحالة",
  "mat.passages": "المقاطع",
  "mat.added": "أُضيف",
  "mat.actions": "الإجراءات",
  "mat.qa": "س&ج",
  "mat.processing": "قيد المعالجة…",
  "mat.ready": "جاهز",
  "mat.failed": "فشل",
  "mat.download": "تنزيل",
  "mat.confirmDelete": "حذف {name}؟ ستُوسم المفاهيم المبنية منه للمراجعة.",
  "mat.pasteAria": "الصق نصًا",
  "mat.pastePlaceholder": "مثال: ملاحظات المحاضرة 3",
  "mat.thisTextIs": "هذا النص هو",
  "mat.asMaterial": "مواد دراسة",
  "mat.asQa": "أسئلة وأجوبة (Domanda: / Risposta:)",
  "mat.text": "النص",
  "mat.textPlaceholderQa": "# موضوع\nDomanda: …?\nRisposta: …",
  "mat.textPlaceholder": "# عنوان\nملاحظاتك…",
  "mat.adding": "جارٍ الإضافة…",
  "mat.addText": "أضف النص",
  "mat.pastedName": "نص ملصق {when}",
  "prop.title": "المنهج المقترح",
  "prop.reading": "يقرأ الذكاء الاصطناعي موادك…",
  "prop.applied": "تم تطبيق هذا الاقتراح بالفعل.",
  "prop.failed": "تعذّر على الذكاء الاصطناعي اقتراح منهج.",
  "prop.blank": "يحتاج كل فصل وموضوع ومفهوم إلى عنوان.",
  "prop.longMaterial": "كانت المواد طويلة: يغطي هذا أول {used} من {total} مقطعًا.",
  "prop.dropped": "استُبعد {n} من المفاهيم المقترحة لتعذّر ربطها بموادك.",
  "prop.hint": "عدّل أي شيء أدناه: أعد التسمية أو الترتيب، انقل المفاهيم بين الموضوعات، ادمج أو احذف أو أضف. لا يُفعَّل شيء: أنت تختار ما تدرسه لاحقًا.",
  "prop.chapterTitle": "عنوان الفصل",
  "prop.deleteChapter": "حذف الفصل",
  "prop.accept": "اقبل المنهج",
  "prop.reject": "ارفض الاقتراح",
  "prop.topicAria": "الموضوع {title}",
  "prop.existingTopic": "موضوع موجود",
  "prop.topicTitle": "عنوان الموضوع",
  "prop.moveTopicUp": "انقل الموضوع للأعلى",
  "prop.moveTopicDown": "انقل الموضوع للأسفل",
  "prop.deleteTopic": "احذف الموضوع",
  "prop.conceptTitle": "عنوان المفهوم",
  "prop.exists": "موجود بالفعل",
  "prop.moveConceptUp": "انقل المفهوم للأعلى",
  "prop.moveConceptDown": "انقل المفهوم للأسفل",
  "prop.moveToTopic": "انقل إلى موضوع",
  "prop.untitled": "موضوع بلا عنوان",
  "prop.merge": "ادمج مع التالي",
  "prop.addConcept": "+ أضف مفهومًا",
  "mkt.intro": "دورات أنشأها مستخدمون آخرون في LEARNABLE. أضف إحداها إلى دوراتك وادرسها بجدولك الخاص: يحدّثها مؤلفها باستمرار. لمشاركة إحدى دوراتك افتحها واملأ \"صفحة السوق\" الخاصة بها.",
  "mkt.categories": "الفئات",
  "mkt.all": "الكل",
  "mkt.searchPlaceholder": "ابحث بالعنوان أو الوصف",
  "mkt.level": "المستوى",
  "mkt.language": "اللغة",
  "mkt.size": "الحجم",
  "mkt.sort": "ترتيب",
  "mkt.any": "أي",
  "mkt.loading": "جارٍ تحميل الدورات…",
  "mkt.noMatch": "لا توجد دورة تطابق هذه المرشحات بعد.",
  "mkt.publishedByMe": "ما نشرته",
  "mkt.status.DRAFT": "مسودة",
  "mkt.status.PUBLISHED": "منشور",
  "mkt.status.UNPUBLISHED": "غير منشور",
  "mkt.version": "الإصدار {n}",
  "mkt.students.one": "{n} طالب",
  "mkt.students.other": "{n} طلاب",
  "mkt.editCourse": "عدّل الدورة وصفحتها",
  "mkt.by": "بواسطة {author}",
  "mkt.inYourCourses": "في دوراتك",
  "mkt.loadingCourse": "جارٍ تحميل الدورة…",
  "mkt.updated": "حُدّث في {date}",
  "mkt.statStudents": "الطلاب",
  "mkt.yourCourse": "دورتك",
  "mkt.draftTag": "مسودة",
  "mkt.notPublishedTag": "غير منشور",
  "mkt.open": "افتح في دوراتي",
  "mkt.addBack": "أعد إضافتها إلى دوراتي",
  "mkt.add": "أضف إلى دوراتي · {price}",
  "mkt.about": "عن هذه الدورة",
  "mkt.learn": "ما ستتعلمه",
  "mkt.audience": "لمن هي",
  "mkt.hiddenNote": "تصبح الأسئلة والأجوبة مرئية بمجرد وجود الدورة في دوراتك. تدرسها داخل LEARNABLE: لا يمكن تنزيل مواد المؤلف.",
  "sales.originTitle": "🛒 من السوق",
  "sales.madeBy": "من إنشاء {author} (الإصدار {version}). يحدّث مؤلفها الفصول والأسئلة والأجوبة باستمرار، لذا لا يمكنك تعديلها هنا: تصلك التحديثات تلقائيًا.",
  "sales.yourStudy": "دراستك ملكك: تفعيل المفاهيم والإيقاف المؤقت وإجاباتك وخطة مراجعتك ونقاطك والأولوية التي تمنحها لكل سؤال (أنت وحدك تراها).",
  "sales.seePage": "اطّلع على صفحتها في السوق",
  "sales.title": "🛒 صفحة السوق",
  "sales.pPublished": "منشور · الإصدار {n}",
  "sales.pNot": "غير منشور",
  "sales.pDraft": "مسودة",
  "sales.pNone": "غير مشارك",
  "sales.explain": "شارك هذه الدورة مع مستخدمين آخرين. هنا تكتب صفحتها، وهي الشيء الوحيد الذي يراه الناس قبل إضافتها: ما تغطيه ولمن هي وما سيتعلمونه. يرون أيضًا عناوين الفصول وعدد الأسئلة؛ أما الأسئلة نفسها فبعد حصولهم عليها فقط، ولا يرون موادك المرفوعة أبدًا.",
  "sales.seeAsOthers": "شاهدها كما يراها الآخرون",
  "sales.edit": "عدّل صفحة السوق",
  "sales.write": "اكتب صفحة سوق",
  "sales.subtitle": "العنوان الفرعي",
  "sales.subtitleHint": "(سطر واحد، مثل \"كل أسئلة الامتحان الشفهي الـ300 مع إجابات نموذجية\")",
  "sales.category": "الفئة",
  "sales.description": "الوصف",
  "sales.descriptionHint": "(ما تغطيه وكيف أعددتها وكيف تُستخدم)",
  "sales.outcomes": "ما سيتعلمه الطلاب",
  "sales.outcomesHint": "(واحد في كل سطر، حتى 8)",
  "sales.tags": "الوسوم",
  "sales.tagsHint": "(مفصولة بفواصل، حتى 8)",
  "sales.saveDraft": "احفظ المسودة",
  "sales.savePage": "احفظ الصفحة",
  "sales.publish": "انشر",
  "sales.publishUpdate": "انشر تحديثًا",
  "sales.publishHintUpdate": "يرسل فصولك وأسئلتك وأجوبتك الحالية إلى كل من لديه الدورة. يُحفظ تقدمهم الخاص.",
  "sales.publishHint": "يجعل الدورة مرئية في السوق. هي مجانية حاليًا. يمكنك مواصلة تعديلها ونشر تحديثات لاحقًا.",
  "sales.rights": "الأسئلة والأجوبة من حقي مشاركتها (كتبتها بنفسي أو أملك حقوق المواد التي جاءت منها).",
  "sales.publishing": "جارٍ النشر…",
  "sales.publishUpdateBtn": "انشر التحديث",
  "sales.unpublish": "إلغاء النشر",
  "sales.noteSaved": "تم الحفظ: تعرضه صفحة السوق الآن.",
  "sales.noteDraft": "تم حفظ المسودة. لن يراها أحد حتى تنشرها.",
  "sales.notePublishedV": "نُشر الإصدار {n}: يحصل كل من لديه الدورة الآن على أحدث أسئلتك.",
  "sales.notePublished": "تم النشر! يمكن للمستخدمين الآخرين العثور عليها الآن في السوق.",
  "sales.noteUnpublished": "أُلغي النشر: لا يستطيع الجدد العثور عليها. ومن لديه الدورة يحتفظ بها.",
  "prog.empty": "أنشئ دورة وابدأ التعلّم لترى تقدمك.",
  "prog.weakConcepts": "مفاهيم ضعيفة",
  "prog.weakMeta": "حالات النسيان: {lapses} · الموسومة صعبة: {hard}",
  "prog.byChapter": "حسب الفصل والموضوع",
  "prog.colChapter": "الفصل / الموضوع",
  "weak.intro": "أخطاء وُجدت في إجاباتك الأخيرة، مرتبة حسب المفهوم. تختفي عندما لا تظهرها آخر إجاباتك عن العنصر. التدريب لا يغيّر جدول مراجعتك.",
  "weak.loading": "جارٍ فحص إجاباتك الأخيرة…",
  "weak.empty": "لا توجد أخطاء متكررة الآن. واصل الإجابة وستظهر هنا.",
  "weak.practiceTop.one": "تدرّب على أهم {n} مفهوم",
  "weak.practiceTop.other": "تدرّب على أهم {n} مفاهيم",
  "weak.practiceThis": "تدرّب على هذا",
  "weak.seen.one": "ظهر {n} مرة، آخرها {date}",
  "weak.seen.other": "ظهر {n} مرات، آخرها {date}",
  "home.intro": "تحافظ المراجعات المجدولة على ما تعلمته. تتبع أعداد المستحقات القواعد نفسها المتبعة في جلسة المراجعة.",
  "home.noCourses": "لا توجد دورات بعد.",
  "home.createOnDashboard": "أنشئ واحدة في لوحتك",
  "home.meta": "{due} مستحقة الآن · تم تقديم {introduced} من {trained} عنصرًا",
  "activity.pageIntro": "الإجابات المكتملة في كل يوم خلال العام الماضي، بمنطقتك الزمنية. تُحتسب الإجابة بمجرد حصولها على تقييم نهائي، صحيحة كانت أم خاطئة.",
  "reset.title": "أعد تعيين كلمة المرور",
  "reset.intro": "أدخل بريد حسابك الإلكتروني. سنرسل رابطًا لاختيار كلمة مرور جديدة؛ يعمل مرة واحدة ولمدة 30 دقيقة.",
  "reset.send": "أرسل رابط إعادة التعيين",
  "reset.sentMessage": "إذا كان هناك حساب لهذا البريد، فإن رابط إعادة تعيين كلمة المرور في طريقه إليك. تحقق من صندوق الوارد (ومجلد الرسائل غير المرغوبة).",
  "reset.back": "العودة إلى تسجيل الدخول",
  "reset.chooseTitle": "اختر كلمة مرور جديدة",
  "reset.incomplete": "هذا الرابط غير مكتمل. افتح الرابط من البريد مرة أخرى أو اطلب رابطًا جديدًا.",
  "reset.done": "تم تغيير كلمة مرورك. تم تسجيل الخروج من كل الأجهزة: سجّل الدخول بكلمة المرور الجديدة.",
  "reset.newPassword": "كلمة المرور الجديدة",
  "reset.repeat": "أعد كتابة كلمة المرور الجديدة",
  "reset.tooShort": "استخدم {n} حرفًا على الأقل.",
  "reset.mismatch": "كلمتا المرور غير متطابقتين.",
  "reset.set": "عيّن كلمة المرور الجديدة",
  "source.aria": "مقطع من المصدر",
  "source.closeAria": "أغلق المصدر",
  "source.loading": "جارٍ تحميل المقطع…",
  "source.open": "افتح مقطع المصدر",
  "course.loadingCurriculum": "جارٍ تحميل المنهج…",
  "mkt.addPlain": "أضف إلى دوراتي",
  "sales.pageName": "صفحة السوق",
};
